<template>
  <van-dialog @close="onClose">
    <div slot="main">
      <el-form class="admin-form" :model="form" ref="form">
        <el-form-item>
          <el-input
            v-model="form.phone"
            ref="phone"
            @keyup.enter.native="autoFocus('code')"
            placeholder="手机号"
            maxlength="11">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="form.code"
            type="text"
            ref="code"
            @keyup.enter.native="autoFocus('newPassword')"
            autocomplete="new-password"
            placeholder="验证码"
            maxlength="6">
          </el-input>
          <van-countdown
            v-if="sended"
            @timeout="sended = false"
            :seconds="60" />
          <el-button v-else @click="sendCode" class="verify-btn">
            <span>获取验证码</span>
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="form.password"
            ref="newPassword"
            @keyup.enter.native="autoFocus('repeat')"
            type="password"
            autocomplete="new-password"
            placeholder="请输入新密码"
            maxlength="30">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="form.repeatPassword"
            ref="repeat"
            type="password"
            @keyup.enter.native="forgetPassword"
            autocomplete="new-password"
            placeholder="请再输入一次新密码"
            maxlength="30">
          </el-input>
        </el-form-item>
        <el-form-item>
          <img class="save-btn" @click="forgetPassword" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/e566f94bd158f34f87a55aeaf17a1e1e.png" alt="" />
        </el-form-item>
      </el-form>
    </div>
  </van-dialog>
</template>

<script>
/* eslint-disable */
import {
  Input,
  Form,
  FormItem,
} from 'element-ui';
import utils from '@/services/utils';
import api from '@/api/graphql/account';
import VanCountdown from '@/components/common/Countdown.vue';
import VanDialog from './Dialog.vue';

export default {
  props: {
  },
  components: {
    VanCountdown,
    VanDialog,
    ElInput: Input,
    ElForm: Form,
    ElFormItem: FormItem,
  },
  data() {
    return {
      opinion: '',
      sended: false,
      form: {
        phone: '',
        code: '',
        password: '',
        repeatPassword: '',
      },
    };
  },
  methods: {
    autoFocus(name) {
      this.$refs[name].focus();
    },
    onClose() {
      this.$emit('close');
    },
    forgetPassword() {
      if (this.form.password !== this.form.repeatPassword) {
        utils.error('两次输入的密码不一致');
        return;
      }
      api.forgetPassword(this.form)
        .then((data) => {
          if (data) {
            utils.success('密码修改成功！');
            this.$emit('success')
          }
        });
    },
    sendCode() {
      const { phone } = this.form;
      if (!phone) {
        utils.error('请输入手机号');
        return;
      }
      if (!/^1[3456789][0-9]{9}$/.test(phone)) {
        utils.error('请输入正确的手机号');
        return;
      }
      this.sended = true;
      api.sendCaptcha({
        phone,
        type: 'student_password_reset',
      }).then(() => {
      }).catch(() => {
        this.sended = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
/deep/ .admin-form{
  padding: 3vh;
  .el-form-item__content {
    display: flex;
  }
  .el-input__inner {
    height: 48px;
    line-height: 48px;
    border-radius: 10px;
    background-color: #f6f5fb;
    border: 1px solid #fff;
    &:focus {
      border: 1px solid #5A5FEF;
      outline: 0;
    }
  }
  .verify-btn {
    font-size: 2vh;
    font-weight: bold;
    color: $primary;
    background-color: #fff;
    border: 0;
  }
  .save-btn {
    margin: 0 auto;
    width: 36%;
    cursor: pointer;
    &:hover {
      opacity: .8;
    }
  }
  .countdown {
    box-sizing: border-box;
    width: 128px;
    height: 48px;
    &:hover {
      cursor: not-allowed;
    }
    .seconds {
      position: relative;
      display: inline-block;
      width: 128px;
      line-height: 48px;
      font-size: 28px;
    }
  }
}
</style>
